import netflix from "@/assets/networks/netflix.svg";
import nbc from "@/assets/networks/nbc.svg";
import fox from "@/assets/networks/fox.svg";
import cbs from "@/assets/networks/cbs.svg";
import abc from "@/assets/networks/abc.svg";
import espn from "@/assets/networks/espn.svg";
import primeVideo from "@/assets/networks/prime-video.svg";

// ESPN names the broadcaster differently depending on how far out kickoff is
// ("NFL Network" one week, "NFL Net" the next, "Prime Video" vs "Amazon Prime
// Video"), so match on a squashed key rather than the exact string. Peacock is
// NBC's streaming feed and carries the same mark.
//
// Every mark here is a flat silhouette in slate-300, so the badge reads as
// chrome beside the kickoff time rather than competing with the team colours
// the card is actually about. That rules out the NFL shield, which is only
// legible in colour -- NFL Network falls through to the text chip instead.
const LOGOS = {
  netflix: { src: netflix, label: "Netflix" },
  nbc: { src: nbc, label: "NBC" },
  peacock: { src: nbc, label: "Peacock" },
  fox: { src: fox, label: "FOX" },
  cbs: { src: cbs, label: "CBS" },
  abc: { src: abc, label: "ABC" },
  espn: { src: espn, label: "ESPN" },
  espn2: { src: espn, label: "ESPN2" },
  espnnews: { src: espn, label: "ESPN" },
  primevideo: { src: primeVideo, label: "Prime Video" },
  amazonprimevideo: { src: primeVideo, label: "Prime Video" },
  amazon: { src: primeVideo, label: "Prime Video" },
};

function normalize(broadcast) {
  return String(broadcast || "")
    .toLowerCase()
    .replace(/\+/g, "")
    .replace(/[^a-z0-9]/g, "");
}

// The network's logo for a broadcast string, or null when we don't have one
// (the caller falls back to plain text).
export function networkLogo(broadcast) {
  if (!broadcast) return null;
  return LOGOS[normalize(broadcast)] || null;
}
